import { h } from "preact";

import { CalculateSubscriptionPriceResponse } from "../../../foundation/api/model";
import { BillingPeriod } from "../../../foundation/enums";
import { formatCurrency } from "../../../foundation/utils/legacy";

import { formatPriceForUI, getPeriodText } from "../../../foundation/utils/payment";

import styles from "./TotalPrice.module.css";

interface Props {
    priceWithTax?: CalculateSubscriptionPriceResponse;
    totalPrice: number;
    billingPeriod: BillingPeriod;
}

export default function TotalPrice({ priceWithTax, totalPrice, billingPeriod }: Props) {
    const finalPrice = priceWithTax ? formatPriceForUI(priceWithTax.total) : totalPrice;

    return (
        <div class={styles.totalPriceContainer}>
            <div class={styles.periodContainer}>
                <div class="heading-4 medium">Total</div>
                <div class="caption-1">Paid {getPeriodText(billingPeriod)}</div>
            </div>
            <div className="heading-4 medium">
                {formatCurrency(finalPrice)}
            </div>
        </div>
    );
}
